import React, { useEffect, useState, useMemo, useContext } from "react";
import { Table, Tag, Space } from "antd";
import _ from "lodash";

import { FindAccusedBaseTable } from "./FindAccusedBaseTable";
import { LanguageContext } from "../../context/LanguageContext";

export const FindAccusedTable = (props) => {
  const { language, setLanguage, t } = useContext(LanguageContext);
  console.log("props", props);

  if (props) {
    props.criminalRecords.forEach((item) => {
      if (
        Array.isArray(item.photo) &&
        item.photo.length === 1 &&
        typeof item.photo[0] === "string" &&
        item.photo[0].includes(",")
      ) {
        const newPhotos = item.photo[0].split(",");

        item.photo = [newPhotos[0], ...newPhotos.slice(1)];

        console.log("Updated item.photo", item.photo);
      }
    });

    props.criminalRecords?.forEach((item) => {
      if (item?.date_from) {
        item.date_from = formatDate(item.date_from);
      }
      if (item?.date_to) {
        item.date_to = formatDate(item.date_to);
      }
    });
  }

  const [criminalData, setCriminalData] = useState([]);
  const [criminalHeaders, setCriminalHeaders] = useState([]);
  const requiredKeys = [
    "Sr.No",    
    "age",
    // "address",
    // "mobileNumber",
    "districtName",
    // "gunhaCount",
  ];

  const requiredKeys1 = [
    t("date_from"),
    t("date_to"),
    t("sr.no"),
    t("name"),
    t("age"),
    // "address",
    // "mobileNumber",
    t("preventive_action_name"),
    t("district_name"),
    // t("total_crimes"),
  ];

  const requiredKeysTitle = [
    t("sr.no"),    
    t("age"),
    // "पत्ता",
    // t("phone_no"),
    t("accused_police_station"),
    // t("total_crimes"),
  ];

  const requiredKeysTitle1 = [
    t("sr.no"),    
    t("age"),
    // "पत्ता",
    // "फोन नंबर",
    t("accused_police_station"),
    t("preventive_action"),
    t("period_from"),
    t("period_to"),
    // t("total_crimes"),
  ];

  function formatDate(dateString) {
    return new Date(dateString).toISOString().split("T")[0];
  }

  const getCityName = (id) => {
    const { pc_cities } = props.criminalRecords;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  useMemo(() => {
    if (props.criminalRecords && props.criminalRecords) {
      let columns1 =
        props.criminalRecords &&
        props.criminalRecords &&
        props.criminalRecords.map((itemObj, index) => {
          return {
            ...itemObj,
            key: index + 1,
          };
        });

      const page_size =
        props?.report === true ||
        props?.ongoing === true ||
        props?.completed === true
          ? props.pageSize - 10
          : props.pageSize;
      let tempObj = columns1.map((res, index) => {
        return {
          ...res,
          photo:
            res.photo && res.photo[0] && res.photo[0].length
              ? res.photo[0]
              : null,
          "Sr.No": props.getSerialNumber(index, props.current, page_size),
        };
      });
      setCriminalData(tempObj);

      let tablelabes =
        columns1 && columns1.length ? Object.keys(columns1[0]) : [];

      if (tablelabes.length) {
        tablelabes.unshift("Sr.No");

        tablelabes = tablelabes.filter(
          (label) => label !== "date_from" && label !== "date_to"
        );

        tablelabes.push("date_from", "date_to");
      }

      let tableColumns = [];
      tablelabes &&
        tablelabes.length &&
        tablelabes.forEach((item) => {
          const requiredKey =
            props?.report === true ||
            props?.ongoing === true ||
            props?.completed === true
              ? requiredKeys1
              : requiredKeys;
          if (
            _.filter(requiredKey, function (o) {
              return o === item;
            }).length
          ) {
            tableColumns.push(item);
          }
        });

      let columnList = tableColumns.map((item, index) => {
        return {
          title:
            props?.report === true ||
            props?.ongoing === true ||
            props?.completed === true
              ? requiredKeysTitle1[index]
              : requiredKeysTitle[index],
          dataIndex: item,
          key: item,
        };
      });
      setCriminalHeaders(columnList);
    }
  }, [props.criminalRecords]);

  const onEditAccusedForm = (data) => {
    props.onEditAccusedForm(data);
  };
  const onPreventiveViewAccusedForm = (data) => {
    props.onPreventiveViewAccusedForm(data);
  };
  const onViewAccusedDetails = (data) => {
    props.onViewAccusedDetails(data);
  };
  const onCriminalActiveStatus = (data) => {
    props.onCriminalActiveStatus(data);
  };
  return (
    <FindAccusedBaseTable
      startDate={props.startDate}
      endDate={props.endDate}
      selectedDate={props.selectedDate}
      preventive_action={props.preventive_action}
      report={props.report}
      ongoing={props?.ongoing}
      completed={props?.completed}
      isAccusedFormUpdate={true}
      onEditAccusedForm={onEditAccusedForm}
      onPreventiveViewAccusedForm={onPreventiveViewAccusedForm}
      onViewAccusedDetails={onViewAccusedDetails}
      onCriminalActiveStatus={onCriminalActiveStatus}
      data={criminalData}
      columns={criminalHeaders}
      usersData={props.usersData}
      pc_crimetypes={props.pc_crimetypes}
      pc_crimetitles={props.pc_crimetitles}
      current={props.current}
      pageSize={props.pageSize}
      total={props.total}
      handlePageChange={props.handlePageChange}
      handlePageSizeChange={props.handlePageSizeChange}
      isseach={props.isseach}
      cityid={props.cityid}
      userRole={props.userRole}
      loading={props.loading}
      user={props?.user}
    ></FindAccusedBaseTable>
  );
};
